import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { isAuthenticated, setRefreshRoute } from 'Graphql/store';
import LoadingScreen from 'Components/ui/LoadingScreen';

const AuthGuard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRefreshRoute(window.location.hash.replace('#', ''));
    if (!isAuthenticated()) {
      navigate('/', { replace: true });
    } else {
      setLoading(false);
    }
  }, [isAuthenticated(), navigate]);

  if (loading) return <LoadingScreen fullScreen size="big" />;

  return <Outlet />;
};

export default AuthGuard;
